import React, { useContext, useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { ClipLoader } from 'react-spinners'
import SwishPaymentApi from '../services/api/SwishPayment'
import InvoiceApi from '../services/api/Invoice'
import { AbortButton, BackButton } from '../utils/Elements'
import SwishError from './SwishError'
import PaymentInfoCustomer from './PaymentInfoCustomer'
import InvoiceStatusHelper from '../helpers/InvoiceStatusHelper'
import InvoiceStatus from './InvoiceStatus'
import PaymentSuccess from './PaymentSuccess'
import Context from '../context/Context'
import { BankIdSigningActions, InvoiceStatuses } from '../helpers/Constants'

const SwishImage = () => {
  return (
    <div className="row mt-5">
      <div className="col-12 text-center">
        <img src="/images/swish.png" className="img-fluid" alt="" />
      </div>
    </div>
  )
}

const Error = ({ message }) => {
  return (
    <div>
      <span>{ message }</span>
    </div>
  )
}

const SwishPending = ({ cellPhone }) => {
  const context = useContext(Context)

  const [loading, setLoading] = useState(true)
  const [invoice, setInvoice] = useState({})
  const [paymentResult, setPaymentResult] = useState({})
  const [error, setError] = useState(null)
  const [counter, setCounter] = useState(0)
  const isSwishSigningInitialized = useRef(false)

  const AbortController = window.AbortController
  const COUNTER_TIMEOUT = 24

  useEffect(() => {
    const abortController = new AbortController()
    const signal = abortController.signal

    if (InvoiceStatusHelper.shouldInvoiceBePaid(context.invoice)) {
      if (paymentResult.short_code >= 400 || counter >= COUNTER_TIMEOUT) {
        return () => {
          setLoading(false)
          abortController.abort()
          return null
        }
      }

      if (!isSwishSigningInitialized.current) {
        const swishPayment = new SwishPaymentApi()
        swishPayment.post(
          context.customer.id,
          context.invoice.ocr,
          cellPhone,
          signal
        )
          .then(res => res.json())
          .then(data => {
            setPaymentResult(data)
            isSwishSigningInitialized.current = true

            if (context.signingActionId === BankIdSigningActions.MOBILE) {
              window.location = `swish:///?paymentrequest?token=${data.entity_id}&callbackurl=${encodeURIComponent(window.location.href)}`
            } else {
              console.warn('Not a mobile device, start bankid manually')
            }
          })
          .catch(error => {
            setError(error.message)
          })
      }

      const intervalId = setInterval(() => {
        const invoiceApi = new InvoiceApi()
        invoiceApi.getPromise(context.invoice.ocr, signal)
          .then(res => res.json())
          .then((data) => {
            setInvoice(data)
          })
          .catch(error => {
            setError(error.message)
            clearInterval(intervalId)
            setLoading(false)
          })

        setCounter(counter => counter + 1)
      }, 10000)

      if (
        Object.keys(invoice).length > 0 &&
        Object.keys(invoice).includes('invoice_status_id') &&
        parseInt(invoice.invoice_status_id) === InvoiceStatuses.FULLY_PAID
      ) {
        return () => {
          setLoading(false)
          clearInterval(intervalId)
          abortController.abort()
          return null
        }
      } else {
        return () => clearInterval(intervalId)
      }
    } else {
      return () => null
    }
  }, [context, cellPhone, paymentResult, counter])

  if (paymentResult.short_code >= 400 || counter >= COUNTER_TIMEOUT) {
    return (
      <div>
        <div className="row mt-5">
          <div className="col-12 text-center">
            <SwishImage />
          </div >
        </div>
        <div className="row mt-4">
          <div className="col-10 offset-1 col-sm-8 offset-sm-2 text-center">
            { (error !== null) ? <Error message={error} /> : null }
            <SwishError errorMsg={paymentResult.message} errorType="INVALID_CELL_PHONE" />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center">
            <BackButton style={context.style} />
          </div>
        </div>
      </div>
    )
  }

  if (parseInt(invoice.invoice_status_id) === InvoiceStatuses.FULLY_PAID) {
    return (
      <div>
        <PaymentInfoCustomer customer={context.customer} />
        <PaymentSuccess />
      </div>
    )
  }

  if (InvoiceStatusHelper.shouldInvoiceBePaid(context.invoice)) {
    return (
      <div>
        <SwishImage />
        <div className="row mt-5">
          <div className="col-12 text-center">
            <div className='sweet-loading'>
              <ClipLoader
                size={75}
                color={'#BF33BD'}
                loading={loading}
              />
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 text-center">
            <span className="paragraph-regular-16">Vänligen starta din Swish-app för att fullfölja betalningen...</span>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 text-center">
            <AbortButton style={context.style} url={context.url} />
          </div>
        </div>
      </div>
    )
  } else {
    return <InvoiceStatus customer={context.customer} invoice={context.invoice} />
  }
}

SwishPending.propTypes = {
  cellPhone: PropTypes.string
}

Error.propTypes = {
  message: PropTypes.string
}

export default SwishPending
